
namespace RioERP.Enquiry {

    @Serenity.Decorators.registerClass()
    export class EnquiryFollowupDialog extends Serenity.EntityDialog<EnquiryFollowupRow, any> {
        protected getFormKey() { return EnquiryFollowupForm.formKey; }
        protected getIdProperty() { return EnquiryFollowupRow.idProperty; }
        protected getLocalTextPrefix() { return EnquiryFollowupRow.localTextPrefix; }
        protected getNameProperty() { return EnquiryFollowupRow.nameProperty; }
        protected getService() { return EnquiryFollowupService.baseUrl; }
        protected getDeletePermission() { return EnquiryFollowupRow.deletePermission; }
        protected getInsertPermission() { return EnquiryFollowupRow.insertPermission; }
        protected getUpdatePermission() { return EnquiryFollowupRow.updatePermission; }

        protected form = new EnquiryFollowupForm(this.idPrefix);

    }
}